import { useMemo } from "react";
import color from "../../../../theme/color";
import { TextTag } from "../../../Tags/Text";
import { TagSizes } from "../../../Tags/utils/theme";

/**
 * 예약상태 enum
 * @notice 장착, 발렛, 출장 공용
 */
export enum RepairStatus {
  /**
   * 예약신청
   */
  PENDING = "예약신청",
  /**
   * 예약신청
   */
  COMPLETED_PAYMENT = "예약신청",
  /**
   * 예약신청
   * @notice order repairStatus에 이렇게 옴..
   */
  PAYMENT_COMPLETED = "예약신청",
  /**
   * 예약확정
   */
  RESERVED = "예약확정",
  /**
   * 예약확정
   * @target REPAIR
   */
  RESERVATION_COMPLETED = "예약확정",
  /**
   * 예약확정
   */
  APPROVED = "예약확정",

  /**
   * 작업완료
   * @target REPAIR
   */
  COMPLETED = "작업완료",
  /**
   * 예약취소
   */
  CANCELED = "예약취소",
  /**
   * 예약취소
   * @target REPAIR
   */
  CANCELED_ORDER = "예약취소",
}

/**
 * 예약상태 key type
 */
export type RepairStatusType = keyof typeof RepairStatus;

/**
 * 예약상태별 컬러
 */
export const reservationStatusTypeColor: {
  [key: string]: string;
} = {
  PENDING: color.secondary3,
  COMPLETED_PAYMENT: color.secondary3,
  PAYMENT_COMPLETED: color.secondary3,
  RESERVED: color.primary3,
  RESERVATION_COMPLETED: color.primary3,
  APPROVED: color.primary3,
  COMPLETED: color.gray2,
  CANCELED: color.red3,
  CANCELED_ORDER: color.red3,
};

interface RepairStatusTagProps {
  value: RepairStatusType;
  size?: TagSizes;
}

/**
 * 예약상태 태그
 * @param value
 * @returns
 */
export const RepairStatusTag: React.FC<RepairStatusTagProps> = ({
  value,
  size,
}) => {
  const targetColor = useMemo(
    () => reservationStatusTypeColor[value] || color.gray4,
    [value]
  );
  return (
    <>
      {RepairStatus[value] ? (
        <TextTag colors={targetColor} size={size}>
          {RepairStatus[value]}
        </TextTag>
      ) : (
        "-"
      )}
    </>
  );
};
